import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';

@Injectable()
export class ThingTypeEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(type: string): void {
    this.broadcaster.broadcast(ThingTypeEvent, type);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(ThingTypeEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/things/ThingTypeEvent.ts